import React, { useCallback, useEffect, useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import {
  Box,
  IconButton,
  Typography,
  Breadcrumbs,
  Grid,
  Menu,
  MenuItem,
  Snackbar,
  Alert,
  Dialog,
  Slide,
  DialogTitle,
  DialogActions,
  Button,
} from "@mui/material";
import {
  ArrowBack,
  Folder,
  InsertDriveFile,
  Home,
  ChevronRight,
  MoreVert,
  Search,
  MoreVertRounded,
  OpenInNew,
  Download,
  DeleteRounded,
} from "@mui/icons-material";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ViewListRoundedIcon from "@mui/icons-material/ViewListRounded";
import { formatteDateDay, pageScrollStyle } from "../../../styles/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteDocFolder,
  deleteDocItem,
  getAllDocFolder,
  getFolderById,
  updateDocFolder,
} from "../../../redux/Apps/Lawyerapp/DocumentSlice/DocumentSlice";
import { backend_api, backend_url } from "../../../static/server";
import { LoadingButton } from "@mui/lab";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { StyledMenu } from "../../../pages/LawyerPages/Documents/DocumentPage";
import { Controller, useForm } from "react-hook-form";
import { useDialog } from "../../DialogContext";
import UploadFileForm from "./UploadFileForm";
import UploadFolderForm from "./UploadFolderForm";
import CreateFolderForm from "./CreateFolderForm";
import CreateDocWithTempForm from "./CreateDocWithTempForm";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const FolderView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { showDialog } = useDialog();
  const basePath = "/dashboard/documents/folder/";
  const [viewMode, setViewMode] = useState("grid");
  const [moreAction, setMoreAction] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedFileFolder, setSelectedFileFolder] = useState({});
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [newDocMenu, setNewDocMenu] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {
      files: null,
      folder: null,
    },
  });

  const onSubmit = (data) => {
    if (data.files) {
      console.log("Uploaded Files:", data.files);
      // Array.from(data.files).forEach((file) => {
      //   console.log(
      //     `File: ${file.name}, Size: ${file.size} bytes, Type: ${file.type}`
      //   );
      // });
      showDialog(<UploadFileForm fileData={data?.files} />, {
        dialogTitle: "Upload File",
      });
    }
  };

  const { token } = useSelector((data) => data.user);
  const { allDocFolder, loading, currentFolderData } = useSelector(
    (state) => state.document
  );
  const { pageSize, rowCount, nextPage, previousPage, count } = useSelector(
    (state) => state.document.docFoldersPagination
  );

  const trimmedPath = location.pathname
    .replace(basePath, "")
    .replace(/\/$/, "");
  const segments = trimmedPath ? trimmedPath.split("/") : [];

  const folders = segments.map((segment) => {
    const [id, name] = segment.split("-");
    return { id, name };
  });
  const currentFolder = folders[folders.length - 1];

  const currentFolderId = currentFolder?.id;

  useEffect(() => {
    if (currentFolderId && token) {
      dispatch(
        getFolderById({
          url: `${backend_api}documents/document/folder/`,
          token: token,
          folderId: currentFolderId,
        })
      );
    } else {
      dispatch(
        getAllDocFolder({
          url: `${backend_api}documents/document/folder/`,
          token: token,
        })
      );
    }
  }, [dispatch, token, currentFolderId]);

  const createItemsFromApiData = () => {
    if (!currentFolderId) {
      return (
        allDocFolder?.map((folder) => ({
          id: `folder-${folder?.id}`,
          name: folder?.folder_name,
          type: "folder",
          size: null,
          modified: formatteDateDay(folder?.created_at),
          originalId: folder?.id,
          isFolder: true,
        })) || []
      );
    }

    if (!currentFolderData) return [];

    const items = [];

    // Add child folders
    if (currentFolderData?.child_folder) {
      currentFolderData?.child_folder?.forEach((folder) => {
        items?.push({
          id: `folder-${folder?.id}`,
          name: folder?.folder_name,
          type: "folder",
          modified: formatteDateDay(folder?.created_at),
          originalId: folder?.id,
          isFolder: true,
        });
      });
    }

    // Add documents
    if (currentFolderData?.documents) {
      currentFolderData?.documents?.forEach((doc) => {
        items?.push({
          id: `file-${doc.id}`,
          name: doc?.file_name,
          type: "file",
          modified: formatteDateDay(doc?.created_at),
          originalId: doc?.id,
          isFolder: false,
          fileUrl: doc?.file,
        });
      });
    }

    return items;
  };

  const items = createItemsFromApiData();

  const showSnackbar = (message, severity = "info") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleBack = () => {
    if (folders.length > 1) {
      const parentPath = folders
        .slice(0, -1)
        .map((f) => `${f.id}-${f.name}`)
        .join("/");
      navigate(`${basePath}${parentPath}`);
    } else {
      navigate("/dashboard/documents");
    }
  };

  const handleItemClick = (item) => {
    if (item.isFolder) {
      const newPath = [...folders, { id: item.originalId, name: item.name }]
        .map((f) => `${f.id}-${f.name}`)
        .join("/");
      navigate(`${basePath}${newPath}`);
    } else {
      window.open(`${backend_url}${item.fileUrl}`, "_blank");
    }
  };

  const handleOpen = (item) => {
    try {
      if (item.isFolder) {
        // Navigate to folder
        const newPath = [...folders, { id: item.originalId, name: item.name }]
          .map((f) => `${f.id}-${f.name}`)
          .join("/");
        navigate(`${basePath}${newPath}`);
        showSnackbar(`Opening folder: ${item.name}`, "success");
      } else {
        // Open file in new window
        if (item.fileUrl) {
          window.open(`${backend_url}${item.fileUrl}`, "_blank");
          showSnackbar(`Opening file: ${item.name}`, "success");
        } else {
          showSnackbar(
            `Cannot open file: ${item.name}. File URL not available.`,
            "error"
          );
        }
      }
    } catch (error) {
      showSnackbar(
        `Error opening ${item.isFolder ? "folder" : "file"}: ${item.name}`,
        "error"
      );
    }
    setMoreAction(null);
  };

  // const downloadFile = async (fileUrl, fileName) => {
  //   try {
  //     const a = document.createElement("a");
  //     a.href = `${backend_url}${fileUrl}`;
  //     a.download = fileName;
  //     a.target = "_blank";
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);
  //     return true;
  //   } catch (error) {
  //     console.error("Download error:", error);
  //     return false;
  //   }
  // };

  // const downloadFolderAsZip = async (folderId, folderName) => {
  //   try {
  //     console.log("Folder download requested:", folderId, folderName);
  //     showSnackbar(
  //       `Folder download not supported yet: ${folderName}`,
  //       "warning"
  //     );
  //     return false;
  //   } catch (error) {
  //     console.error("Folder download error:", error);
  //     return false;
  //   }
  // };

  // const handleDownload = async (item) => {
  //   try {
  //     if (item.isFolder) {
  //       showSnackbar(`Preparing folder download: ${item.name}...`, "info");
  //       const success = await downloadFolderAsZip(item.originalId, item.name);

  //       if (success) {
  //         showSnackbar(
  //           `Folder downloaded successfully: ${item.name}`,
  //           "success"
  //         );
  //       } else {
  //         showSnackbar(
  //           `This folder is not able to download: ${item.name}`,
  //           "error"
  //         );
  //       }
  //     } else {
  //       if (item.fileUrl) {
  //         showSnackbar(`Downloading file: ${item.name}...`, "info");
  //         const success = await downloadFile(item.fileUrl, item.name);

  //         if (success) {
  //           showSnackbar(
  //             `File downloaded successfully: ${item.name}`,
  //             "success"
  //           );
  //         } else {
  //           showSnackbar(
  //             `This file is not able to download: ${item.name}`,
  //             "error"
  //           );
  //         }
  //       } else {
  //         showSnackbar(
  //           `This file is not able to download: ${item.name}. File URL not available.`,
  //           "error"
  //         );
  //       }
  //     }
  //   } catch (error) {
  //     showSnackbar(
  //       `This ${item.isFolder ? "folder" : "file"} is not able to download: ${
  //         item.name
  //       }`,
  //       "error"
  //     );
  //   }
  //   setMoreAction(null);
  // };
  const handleDeleteDialog = useCallback(
    (item) => {
      console.log(item);
      setMoreAction(null);
      setSelectedFileFolder({
        id: item?.originalId,
        name: item?.name,
        isFolder: item?.isFolder,
      });
      setOpenDeleteDialog(true);
    },
    [setMoreAction, setSelectedFileFolder, setOpenDeleteDialog]
  );

  const handleDeleteFileFoder = async () => {
    if (!selectedFileFolder) return;
    try {
      setIsDeleting(true);
      if (selectedFileFolder?.isFolder) {
        await dispatch(
          deleteDocItem({
            url: `${backend_api}documents/document/folder/${selectedFileFolder.id}/`,
            token: token,
          })
        ).unwrap();
      } else {
        await dispatch(
          deleteDocItem({
            url: `${backend_api}documents/document/${selectedFileFolder.id}/`,
            token: token,
          })
        ).unwrap();
      }
      dispatch(
        getFolderById({
          url: `${backend_api}documents/document/folder/`,
          token: token,
          folderId: currentFolderId,
        })
      );

      setOpenDeleteDialog(false);
      setSelectedFileFolder(null);
    } catch (error) {
      console.error("Error deleting folder:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleMoreActionClick = (e, item) => {
    e.stopPropagation();
    setSelectedItem(item);
    setMoreAction(e.currentTarget);
  };

  const handleBreadcrumbClick = (index) => {
    if (index === -1) {
      navigate("/dashboard/documents");
    } else {
      const targetPath = folders
        .slice(0, index + 1)
        .map((f) => `${f.id}-${f.name}`)
        .join("/");
      navigate(`${basePath}${targetPath}`);
    }
  };

  const getCurrentFolderName = () => {
    if (!currentFolderId) return "Documents";
    return (
      currentFolderData?.folder_name || currentFolder?.name || "Loading..."
    );
  };

  const handleDragStart = (e, item) => {
    e.preventDefault();
    e.dataTransfer.setData("dragItem", JSON.stringify(item));
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = async (e, dropTarget) => {
    e.preventDefault();
    const dragItem = JSON.parse(e.dataTransfer.getData("dragItem"));

    if (dragItem.id === dropTarget.id) {
      showSnackbar("Cannot move an item onto itself", "error");
      return;
    }

    // Cannot drop file on file or folder on file
    if (!dropTarget.isFolder) {
      showSnackbar("You can only drop into folders", "error");
      return;
    }

    // First: remove from source folder
    try {
      const dragItem = JSON.parse(e.dataTransfer.getData("dragItem"));

      if (!dragItem) {
        showSnackbar("Invalid drag data", "error");
        return;
      }
      const sourceFolderId = currentFolderId;

      // Remove from source
      await dispatch(
        updateDocFolder({
          url: `${backend_api}documents/document/folder/${sourceFolderId}/`,
          token: token,
          body: {
            remove_files: dragItem.isFolder ? [] : [dragItem.originalId],
            remove_folders: dragItem.isFolder ? [dragItem.originalId] : [],
          },
        })
      ).unwrap();

      // Add to destination
      await dispatch(
        updateDocFolder({
          url: `${backend_api}documents/document/folder/${dropTarget.originalId}/`,
          token: token,
          body: {
            add_files: dragItem.isFolder ? [] : [dragItem.originalId],
            add_folders: dragItem.isFolder ? [dragItem.originalId] : [],
          },
        })
      ).unwrap();

      showSnackbar("Item moved successfully", "success");

      dispatch(
        getFolderById({
          url: `${backend_api}documents/document/folder/`,
          token: token,
          folderId: currentFolderId,
        })
      );
    } catch (error) {
      console.error("Move failed:", error);
      showSnackbar("Error moving item", "error");
    }
  };

  return (
    <div className="w-full h-full flex flex-col gap-4">
      <div className="flex justify-between bg-white rounded-lg items-center shadow-md p-2">
        <div className="flex items-center gap-2">
          <IconButton onClick={handleBack} size="small" sx={{ color: "#666" }}>
            <ArrowBack />
          </IconButton>

          <Breadcrumbs
            separator={<ChevronRight fontSize="small" />}
            sx={{ ml: 1 }}
          >
            <Box
              component="button"
              onClick={() => handleBreadcrumbClick(-1)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#666",
                fontSize: "0.8rem",
                "&:hover": { color: "primary.dark" },
              }}
            >
              <Home fontSize="small" />
              Documents
            </Box>
            {folders?.map((folder, index) => (
              <Box
                key={`breadcrumb-${folder.id}-${index}`}
                component="button"
                onClick={() => handleBreadcrumbClick(index)}
                sx={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: index === folders.length - 1 ? "primary.dark" : "#666",
                  fontSize: "0.8rem",
                  fontWeight: index === folders.length - 1 ? 600 : 400,
                  "&:hover": { color: "primary.dark" },
                }}
              >
                {folder.name}
              </Box>
            ))}
          </Breadcrumbs>
        </div>

        <div className="flex items-center gap-2">
          <IconButton size="small" sx={{ color: "#666" }}>
            <Search />
          </IconButton>
          <IconButton
            onClick={() => setViewMode(viewMode === "grid" ? "list" : "grid")}
            size="small"
            sx={{ color: "#666" }}
          >
            {viewMode === "grid" ? (
              <ViewListRoundedIcon />
            ) : (
              <GridViewRoundedIcon />
            )}
          </IconButton>
          <Box className="flex gap-4">
            <Button
              id="demo-customized-button"
              variant="contained"
              disableElevation
              onClick={(e) => setNewDocMenu(e.currentTarget)}
              endIcon={<KeyboardArrowDownRoundedIcon />}
              size="small"
            >
              New Document
            </Button>
            <StyledMenu
              id="demo-customized-menu"
              MenuListProps={{ "aria-labelledby": "demo-customized-button" }}
              anchorEl={newDocMenu}
              open={Boolean(newDocMenu)}
              onClose={() => setNewDocMenu(null)}
            >
              <Controller
                name="files"
                control={control}
                render={({ field: { onChange } }) => (
                  <input
                    type="file"
                    multiple
                    style={{ display: "none" }}
                    onChange={(e) => {
                      onChange(e.target.files);
                      setNewDocMenu(null);
                      handleSubmit(onSubmit)();
                    }}
                  />
                )}
              />
              <MenuItem
                onClick={() => {
                  const fileInput = document.querySelector(
                    'input[type="file"][multiple]'
                  );
                  if (fileInput) fileInput.click();
                }}
                disableRipple
              >
                Upload files
              </MenuItem>

              <Controller
                name="folder"
                control={control}
                render={({ field: { onChange } }) => (
                  <input
                    type="file"
                    webkitdirectory="true"
                    directory="true"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      const files = e.target.files;
                      if (files.length > 0) {
                        const firstFilePath = files[0].webkitRelativePath;
                        const folderName = firstFilePath.split("/")[0];
                        showDialog(
                          <UploadFolderForm
                            folderData={{ name: folderName, files }}
                            currentFolderData={currentFolderData}
                          />,
                          {
                            dialogTitle: `Upload Folder - ${folderName}`,
                          }
                        );
                      }

                      setNewDocMenu(null);
                    }}
                  />
                )}
              />
              <MenuItem
                onClick={() => {
                  const folderInput = document.querySelector(
                    'input[type="file"][webkitdirectory]'
                  );
                  if (folderInput) folderInput.click();
                }}
                disableRipple
              >
                Upload folder
              </MenuItem>

              <MenuItem
                onClick={() => {
                  setNewDocMenu(null);
                  showDialog(
                    <CreateFolderForm currentFolderData={currentFolderData} />,
                    {
                      dialogTitle: "Create Folder",
                    }
                  );
                }}
                disableRipple
              >
                Create folder
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setNewDocMenu(null);
                  showDialog(<CreateDocWithTempForm />, {
                    dialogTitle: "Create Document ",
                  });
                }}
                disableRipple
              >
                Create document from template
              </MenuItem>
            </StyledMenu>
          </Box>
        </div>
      </div>

      <Box
        className="bg-white rounded-lg justify-between h-[80vh] p-2 w-full shadow-lg"
        sx={{ ...pageScrollStyle, overflow: "auto" }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            gap: "0.5rem",
            mb: "1rem",
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: 600, color: "#333" }}>
            {getCurrentFolderName()}
          </Typography>
          <Typography variant="body2" sx={{ color: "#666" }}>
            {loading ? "Loading..." : `${items.length} items`}
          </Typography>
        </Box>

        {loading && (
          <div className="text-center py-12">
            <Typography variant="body1" sx={{ color: "#666" }}>
              Loading...
            </Typography>
          </div>
        )}

        {!loading && (
          <>
            {viewMode === "grid" && (
              <Grid container spacing={2}>
                {items.map((item) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item.id}>
                    <Box
                      draggable={true}
                      onDragStart={(e) => handleDragStart(e, item)}
                      onDragOver={handleDragOver}
                      onDrop={(e) => handleDrop(e, item)}
                      sx={{
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        p: "1rem",
                        borderRadius: "1rem",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        "&:hover": {
                          transform: "translateY(-2px)",
                          boxShadow: 3,
                        },
                      }}
                      onClick={() => handleItemClick(item)}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <Box>
                          {item.isFolder ? (
                            <Folder
                              sx={{ fontSize: "2rem", color: "#FFA726" }}
                            />
                          ) : (
                            <InsertDriveFile
                              sx={{ fontSize: "2rem", color: "#42A5F5" }}
                            />
                          )}
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              width: "7rem",
                              fontWeight: 400,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item?.name}
                          </Typography>

                          <Typography
                            variant="body1"
                            sx={{ fontSize: "0.6rem", color: "text.secondary" }}
                          >
                            {item?.modified}
                          </Typography>
                        </Box>
                      </Box>
                      <Box>
                        <IconButton
                          id="more-action"
                          onClick={(e) => handleMoreActionClick(e, item)}
                        >
                          <MoreVertRounded sx={{ fontSize: "0.9rem" }} />
                        </IconButton>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            )}

            {/* List View */}
            {viewMode === "list" && (
              <div className="space-y-1">
                {/* Header */}
                <div className="grid grid-cols-12 gap-4 px-4 py-2 bg-gray-50 rounded text-sm font-medium text-gray-600">
                  <div className="col-span-6">Name</div>
                  <div className="col-span-3">Upload At</div>
                  <div className="col-span-1"></div>
                </div>

                {/* Items */}
                {items.map((item) => (
                  <div
                    key={item.id}
                    className="grid grid-cols-12 gap-4 px-4 py-3 hover:bg-gray-50 rounded cursor-pointer group"
                    onClick={() => handleItemClick(item)}
                  >
                    <div className="col-span-6 flex items-center gap-3">
                      {item.isFolder ? (
                        <Folder sx={{ fontSize: 20, color: "#FFA726" }} />
                      ) : (
                        <InsertDriveFile
                          sx={{ fontSize: 20, color: "#42A5F5" }}
                        />
                      )}
                      <span className="truncate">{item.name}</span>
                    </div>

                    <div className="col-span-3 flex items-center text-sm text-gray-600">
                      {item.modified}
                    </div>
                    <div className="col-span-1 flex items-center justify-end">
                      <IconButton
                        size="small"
                        onClick={(e) => handleMoreActionClick(e, item)}
                        sx={{
                          opacity: 0,
                          ".group:hover &": { opacity: 1 },
                        }}
                      >
                        <MoreVert fontSize="small" />
                      </IconButton>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Empty State */}
            {items.length === 0 && !loading && (
              <div className="text-center py-12">
                <Folder sx={{ fontSize: 64, color: "#ccc", mb: 2 }} />
                <Typography variant="h6" sx={{ color: "#666", mb: 1 }}>
                  This folder is empty
                </Typography>
                <Typography variant="body2" sx={{ color: "#999" }}>
                  No files or folders found
                </Typography>
              </div>
            )}
          </>
        )}
      </Box>

      {/* Menu */}
      <Menu
        id="more-action-menu"
        anchorEl={moreAction}
        open={Boolean(moreAction)}
        onClose={() => setMoreAction(null)}
        slotProps={{
          list: {
            "aria-labelledby": "more-action-button",
          },
        }}
      >
        <MenuItem onClick={() => selectedItem && handleOpen(selectedItem)}>
          <OpenInNew sx={{ fontSize: "1rem", mr: 1 }} />
          Open
        </MenuItem>
        {/* <MenuItem onClick={() => handleDownload(selectedItem)}>
          <Download sx={{ fontSize: "1rem", mr: 1 }} />
          Download
        </MenuItem> */}
        <MenuItem
          sx={{ color: "danger.main" }}
          onClick={() => selectedItem && handleDeleteDialog(selectedItem)}
        >
          <DeleteRounded sx={{ fontSize: "1rem", mr: 1 }} />
          Delete
        </MenuItem>
      </Menu>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Dialog
        open={openDeleteDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpenDeleteDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {selectedFileFolder
            ? `Are you sure you want to delete "${selectedFileFolder.name}"?`
            : "Delete Folder"}
        </DialogTitle>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => {
              setOpenDeleteDialog(false);
              setSelectedFileFolder(null);
            }}
          >
            Cancel
          </Button>
          <LoadingButton
            loading={isDeleting}
            size="small"
            color="error"
            variant="contained"
            onClick={handleDeleteFileFoder}
          >
            Delete
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FolderView;
